import { useCallback, useMemo, useState } from "react";
import { INicheOption } from "../../popups/AddToNichePopup/types";

type TUseSearchNiches = {
  nicheFields: INicheOption[];
  suggestNicheFields: INicheOption[];
}

export const useSearchNiches = ({
  nicheFields,
  suggestNicheFields
}: TUseSearchNiches) => {
  const [text, setText] = useState("");

  const handleChange = useCallback((value: string) => {
    setText(value);
  }, []);

  const { filteredNicheFields, filteredSuggestNicheFields } = useMemo(() => {
    const filterFields = (fields: INicheOption[]) => fields.filter(
      niche => niche.name.toLowerCase().includes(text.toLowerCase())
    );

    const nicheFieldsFiltered = filterFields(nicheFields);
    const suggestNicheFieldsFiltered = filterFields(suggestNicheFields);

    return {
      filteredNicheFields: nicheFieldsFiltered,
      filteredSuggestNicheFields: suggestNicheFieldsFiltered
    };
  }, [nicheFields, suggestNicheFields, text]);

  return {
    text,
    handleChange,
    filteredNicheFields,
    filteredSuggestNicheFields,
  };
};
